/** Where the Spec Grants app is mounted, which every in-app path is relative to. */
export const specGrantsBasePath = "/spec-grants";

/** Where a request's page lives, relative to the Spec Grants base path. */
export const requestHref = (cycleId: string, requestId: string) =>
  `/requests/${encodeURIComponent(cycleId)}/${encodeURIComponent(requestId)}`;

/** Where a request's page lives from outside the Spec Grants app, which a link reaches with a full page load. */
export const buildSpecGrantsRequestHref = (
  cycleId: string,
  requestId: string,
) => `${specGrantsBasePath}${requestHref(cycleId, requestId)}`;

/** The element id a comment or reply carries on its request's page. */
export const messageAnchorOf = (commentId: string) =>
  `message-${encodeURIComponent(commentId)}`;

/** Where a comment or reply sits on its request's page. */
export const messageHref = (
  cycleId: string,
  requestId: string,
  commentId: string,
) => `${requestHref(cycleId, requestId)}#${messageAnchorOf(commentId)}`;

/** The element id a question carries on its request's page. */
export const questionAnchorOf = (questionId: string) =>
  `question-${encodeURIComponent(questionId)}`;

/** Where a question to the applicant, and its replies, sit on its request's page. */
export const questionHref = (
  cycleId: string,
  requestId: string,
  questionId: string,
) => `${requestHref(cycleId, requestId)}#${questionAnchorOf(questionId)}`;
